<script setup lang="ts">
import { UiButtonVariant } from '@afs/design-system'
import type { ArticlesListProps, ArticlesListEvents } from './interface'
import { useI18n } from 'vue-i18n'

defineProps<ArticlesListProps>()
defineEmits<ArticlesListEvents>()
const { t } = useI18n()
</script>

<template>
  <div class="ArticlesList">
    <div class="ArticlesList__top">
      <h2 class="heading-2 color-blue-01">{{ activeFilter }}</h2>
      <p class="paragraph-2 color-blue-01">
        {{ count }}&nbsp;{{ t('advices.filters.articlesLabel', { activeFilter: activeFilter }) }}
      </p>
    </div>
    <ul class="ArticlesList__list grid g-4">
      <li
        v-for="article in articles"
        :key="article.id"
        class="ArticlesList__item"
      >
        <molecules-ui-card v-bind="article" />
      </li>
    </ul>
    <div class="ArticlesList__bottom">
      <atoms-ui-button
        v-if="showMoreBtn"
        :text="t('advices.showMore.label')"
        :variant="UiButtonVariant.OUTLINE"
        class="mb-3"
        @click="$emit('articlesList::loadMore')"
      />
      <p class="paragraph-4 color-blue-01">
        {{ t('advices.showMore.on', { articlesCount: articles.length, totalCount: count }) }}
      </p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@use 'sass:map';
@use 'config/spaces';
@use 'utilities/mq';

.ArticlesList {
  display: flex;
  flex-direction: column;
  gap: map.get(spaces.$sizes, '5');

  @include mq.media('>=medium') {
    gap: map.get(spaces.$sizes, '6');
  }
}

.ArticlesList__top {
  display: flex;
  flex-direction: column;
  align-items: start;
  gap: map.get(spaces.$sizes, '1');
  padding: 0 map.get(spaces.$sizes, '3');

  @include mq.media('>=medium') {
    flex-direction: row;
    gap: map.get(spaces.$sizes, '4');
    align-items: baseline;
    padding: 0 map.get(spaces.$sizes, '5');
  }
}

.ArticlesList__item {
  grid-column: span 4;

  .Card {
    height: 100%;
  }
}

.ArticlesList__bottom {
  text-align: center;
}
</style>
